import Flex from "components/common/Layout/Flex/Flex";
import SelectComp from "components/common/Select/SelectComp";
import { useCheckoutInformation } from "components/forms/useCheckoutInformation";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import CheckoutFormTextField, {
  StyledInput,
  StyledLabel,
} from "./common/CheckoutFormTextField";
import { Input, SubmitButton } from "./TwoColSingleFeatureWithStats2";

export const Form = styled.form`
  font-size: 14px;
  width: 60vw;
  ${tw`mx-auto max-w-xs`}
`;

export const StyledFormField = styled(CheckoutFormTextField)`
  width: 100%;
`;

const StyledFlex = styled(Flex)`
  gap: 0;
`;

const StyledFlexRow = styled(StyledFlex)`
  flex-direction: row;
  width: 100%;
  gap: 10px;
`;

const MonthYearFields = styled(StyledInput)`
  width: 3rem;
`;

const MonthYearLabel = styled(StyledLabel)`
  font-weight: 600;
`;

const StyledSectionDivider = styled.p`
  border-bottom: 1px solid rgba(58, 81, 115, 0.4);
  margin-bottom: 4px;
  width: 80%;
  ${tw`text-[14px] mt-4 text-center md:text-left font-medium leading-relaxed text-secondary-100`}
`;

const CheckoutForm = () => {
  // const {
  //   countries,
  //   cities,
  //   states,
  //   selectedCountry,
  //   setSelectedCity,
  //   setSelectedState,
  //   setSelectedCountry,
  //   generateStatesAndCities,
  //   generateCitiesAgainstStates,
  // } = useCheckoutInformation();

  const navigate = useNavigate();
  const fieldProps = {
    style: {
      width: "100%",
    },
  };
  return (
    <Form
      onSubmit={(e) => {
        navigate("/");
      }}
    >
      <StyledFlex alignItems="start">
        <StyledFormField
          containerProps={{ ...fieldProps }}
          label="Name on Card"
        />
        <StyledFormField
          containerProps={{ ...fieldProps }}
          label="Credit Card Number"
          placeholder="XXXX-XXXX-XXXX-XXXX"
        />
        <StyledFlexRow direction="row">
          <StyledFormField
            containerProps={{ style: { width: "125%", marginRight: "10px" } }}
            label="Security Code"
          />
          <StyledFlex alignItems="start" direction="column">
            <MonthYearLabel>Expiration Date</MonthYearLabel>
            <StyledFlex style={{ gap: "10px" }} direction="row">
              <MonthYearFields label="" placeholder="MM" maxLength={2} />
              <MonthYearFields label="" placeholder="YY" maxLength={2} />
            </StyledFlex>
          </StyledFlex>
        </StyledFlexRow>
        <StyledSectionDivider>BILLING ADDRESS:</StyledSectionDivider>
        <StyledFlexRow>
          <StyledFormField
            containerProps={{ ...fieldProps }}
            label="First Name"
          />{" "}
          <StyledFormField
            containerProps={{ ...fieldProps }}
            label="Last Name"
          />
        </StyledFlexRow>
        <StyledFormField
          containerProps={{ ...fieldProps }}
          label="Billing Address"
        />
        <StyledFormField containerProps={{ ...fieldProps }} label="City" />
        <StyledFlexRow>
          <StyledFormField
            containerProps={{ ...fieldProps }}
            label="ZIP Code"
          />{" "}
          <StyledFormField containerProps={{ ...fieldProps }} label="Country" />
        </StyledFlexRow>
        <SubmitButton type="submit">Checkout</SubmitButton>
      </StyledFlex>
    </Form>
  );
};

export default CheckoutForm;
